// The sandbox demo's test data.
//
// The IBANs and PSU logins come from the server (window.DEMO_DATA), which sends
// them only on a sandbox deployment - see demo_data() in app/routes.py. A bank
// running this against its own customers gets an empty object and everything
// here quietly becomes a no-op.
//
// The server sends one IBAN per bank on purpose: it is the one that bank really
// holds as an account in its sandbox. Offering the others gets
// "Account with the IBAN not found".
(function (global) {
  "use strict";

  const demoData = global.DEMO_DATA || {};

  // [{ bank, iban }] across every bank the demo can offer.
  const testIbans = Object.entries(demoData).flatMap(([bank, entry]) =>
    (entry.ibans || []).map((iban) => ({ bank, iban }))
  );

  // { bank: { username, password? } } for the banks that publish a test user.
  const psuData = Object.fromEntries(
    Object.entries(demoData)
      .filter(([, entry]) => entry.psu)
      .map(([bank, entry]) => [bank, entry.psu])
  );

  // Which IBANs have already been handed out, so adding several fields does
  // not fill them all with the same bank.
  let selectedIbans = [];

  function getRandomIban() {
    // Outside a sandbox there are none, and the field is left for the
    // customer to fill in.
    if (testIbans.length === 0) return "";

    let available = testIbans.filter(
      (item) => !selectedIbans.includes(item.iban)
    );
    if (available.length === 0) {
      selectedIbans = [];
      available = testIbans;
    }

    const chosen = available[Math.floor(Math.random() * available.length)];
    selectedIbans.push(chosen.iban);
    return chosen.iban;
  }

  function resetOfferedIbans() {
    selectedIbans = [];
  }

  const api = { testIbans, psuData, getRandomIban, resetOfferedIbans };
  if (typeof module !== "undefined" && module.exports) {
    module.exports = api;
  }
  Object.assign(global, api);
})(typeof window !== "undefined" ? window : globalThis);
